"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function newBlockVisitor(ctx, revision) {
    return {
        get revision() { return revision; },
        get: () => ctx.driver.getBlock(revision)
    };
}
exports.newBlockVisitor = newBlockVisitor;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmxvY2stdmlzaXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ibG9jay12aXNpdG9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsU0FBZ0IsZUFBZSxDQUMzQixHQUFZLEVBQ1osUUFBeUI7SUFHekIsT0FBTztRQUNILElBQUksUUFBUSxLQUFLLE9BQU8sUUFBUSxDQUFBLENBQUMsQ0FBQztRQUNsQyxHQUFHLEVBQUUsR0FBRyxFQUFFLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsUUFBUSxDQUFDO0tBQzNDLENBQUE7QUFDTCxDQUFDO0FBVEQsMENBU0MifQ==